// this event caused by the intersection of a ObstacleSideSegment and the other cone side of the same cone
// when this event happens the cone has to be removed
import { SweepEvent } from './SweepEvent';
export class ConeClosureEvent extends SweepEvent {
    get ConeToClose() {
        return this.coneToClose;
    }
    get Site() {
        return this.site;
    }
    constructor(site, cone) {
        super();
        this.site = site;
        this.coneToClose = cone;
    }
    toString() {
        return 'ConeClosureEvent ' + this.site;
    }
}
//# sourceMappingURL=ConeClosureEvent.js.map